export const JOB_TITLES = {
  admin: "Managing Director",
  hr_manager: "HR Manager",
  project_manager: "Project Manager",
  procurement_manager: "Procurement Manager",
  store_keeper: "Inventory Manager",
  supervisor: "Supervisor",
  site_engineer: "Project Engineer",
  accountant: "Finance Controller",
  foreman: "Foreman",
  labour_worker: "Site Personnel",
  driver: "Driver",
  security_guard: "Security Guard",
  electrician: "Electrician",
  plumber: "Plumber",
  mason: "Mason",
  carpenter: "Carpenter",
  welder: "Welder",
  helper: "Helper",
  vendor_supplier: "Vendor / Supplier",
  client: "Client",
};

const ROLE_TITLES = {
  admin: "Managing Director",
  accountant: "Finance Controller",
  supervisor: "Supervisor",
  employee: "Project Engineer",
  vendor: "Vendor Partner",
  client: "Client",
};

export const userTitle = (user) => JOB_TITLES[user?.job_role] || ROLE_TITLES[user?.role] || "";

export const FALLBACK_JOB_ROLES = [
  { value: "admin", label: "Managing Director", access: "admin" },
  { value: "accountant", label: "Finance Controller", access: "accountant" },
  { value: "site_engineer", label: "Project Engineer", access: "employee" },
  { value: "store_keeper", label: "Inventory Manager", access: "employee" },
  { value: "procurement_manager", label: "Procurement Manager", access: "supervisor" },
  { value: "hr_manager", label: "HR Manager", access: "admin" },
  { value: "labour_worker", label: "Site Personnel", access: "employee" },
  { value: "driver", label: "Driver", access: "employee" },
  { value: "security_guard", label: "Security Guard", access: "employee" },
];

export const roleOptions = (jobRoles, current) => {
  const opts = jobRoles?.length ? jobRoles : FALLBACK_JOB_ROLES;
  if (current && !opts.some((r) => r.value === current)) {
    return [{ value: current, label: JOB_TITLES[current] || current, access: "" }, ...opts];
  }
  return opts;
};

export const FIELD_STAFF_JOB_ROLES = ["labour_worker", "security_guard", "electrician", "plumber", "mason", "carpenter", "welder", "helper"];

export const homePath = (user) => {
  if (!user) return "/login";
  if (user.role === "admin") return "/admin";
  if (user.role === "accountant") return "/finance/dashboard";
  if (user.role === "vendor") return "/vendor";
  if (user.role === "client") return "/portal";
  if (user.job_role === "procurement_manager") return "/procurement/dashboard";
  if (user.job_role === "store_keeper") return "/inventory/dashboard";
  if (user.job_role === "driver") return "/driver/dashboard";
  if (FIELD_STAFF_JOB_ROLES.includes(user.job_role)) return "/site/dashboard";
  return "/engineer/dashboard";
};
